import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {SoldPolicyImport} from '../interface/sold-policy-import';
import {first, take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {Uuid} from '../interface/response/uuid';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SoldPolicyImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<SoldPolicyImport>>
    = new ReplaySubject<CountedAndPaginated<SoldPolicyImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadImportList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/sold-policy-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<SoldPolicyImport>) => {
        this.importListSubject.next(result);
      });
  }

  public downloadImportsReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/sold-policy-import/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/sold-policy-import/${importId}/downloadFile`;
  }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/sold-policy-import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }
}
